<template>
  <div class="row justify-center">
    <!-- <CategoryLevel1Bar
      class="bg-info col-12 col-sm-12 col-md-12"
      :L1="L1"
      @update-category="onChangeCategoryL1"
      @update-category-by-click="onChangeCategoryL1ByClick"
    />

    <CategoryLevel2Bar
      class="bg-info col-12 col-sm-12 col-md-12"
      :L1="currentCategoryL1"
      :current="currentCategoryL2"
      @update-category="onChangeCategoryL2"
    />

    <CategoryLevel3
      ref="Level3"
      class="col-12"
      :L1="currentCategoryL1"
      :L2="currentCategoryL2"
      :current="currentCategoryL3"
      @update-category="onChangeCategoryL3"
      :list="categoryL3"
    /> -->

    <q-infinite-scroll
      v-if="!loading"
      class="col-12"
      ref="scrollContent"
      style="padding: 0px 0px 0px 0px; margin-bottom: 60px;"
      :disable="disable && false"
      :offset="1000"
      :debounce="100"
      @load="onLoad"
      @touchstart="onTouchStart($event)"
      @touchmove="onTouchMove($event)"
      @touchend="onTouchEnd($event)"
    >

      <div class="row" style="padding: 0px 0px 0px 0px">

        <div
          class="full-width bg-white row justify-center"
          :style="topWhiteSpace"
        >
          <q-spinner-dots color="primary" size="40px" />
        </div>

        <div
          class="row full-width"
          v-if="productCardComponent === 'ProductCardH'"
        >
          <!-- <div
          class="col-xs-6 col-sm-4 col-md-2"
            v-for="(item, index) in items"
            :key="index"
            style="height: 200px; border: 1px solid red"
          /> -->
          <ProductCardH
            :style="`padding: 4px;`"
            class="product-card-h col-xs-12 col-sm-6 col-md-4"
            v-for="(item, index) in filteredItems"
            :key="(item.cprcode << 16) + index"
            :info="item"
            :maxRetry="10"
          />
        </div>
        <!-- <div class="row full-width" v-else>
          <ProductCardHLarge
            :style="`padding: ${isDesktop ? 4 : 0}px;`"
            class="product-card-h col-xs-12 col-sm-6 col-md-3"
            v-for="(item, index) in items"
            :key="(item.cprcode << 16) + index"
            :info="item"
            :maxRetry="10"
            @add-to-cart="AddToCart(item)"
          />
        </div> -->
      </div>

    </q-infinite-scroll>
  </div>
</template>

<script>
// import delay from "@/utils/delay";
// import CategoryLevel1Bar from "@/ui/pages/allProduct/CategoryLevel1Bar.vue";
// import CategoryLevel2Bar from "@/ui/pages/allProduct/CategoryLevel2Bar.vue";
// import CategoryLevel3 from "@/ui/pages/allProduct/CategoryLevel3";
import useCart from "@/mixins/useCart";
import { QInfiniteScroll, QSpinnerDots, QSpinner } from "quasar";
const components = {
  QInfiniteScroll,
  QSpinnerDots,
  QSpinner,
};
import MenuBar from "@/ui/components/MenuBar";

// const sizeList = ["fas fa-th-large", "fas fa-th"];

export default {
  name: "AllProduct",
  components: {
    ...components,
    // CategoryLevel1Bar,
    // CategoryLevel2Bar,
    // CategoryLevel3,
    // MenuBar,
    ProductCardH: () => import("@/ui/components/ProductCardH"),
    // ProductCardHLarge: () => import("@/ui/components/ProductCardHLarge"),
    // FilterGroup: () => import("@/ui/components/FilterGroup"),
  },
  // props: ["L1"],
  mixins: [useCart],
  data() {
    return {
      threshold: 150,
      touchPoint: {
        startLeft: 0,
        startTop: 0,
        startTime: 0,
      },
      distance: {
        left: 0,
        top: 0,
      },
      translateY: 0,
      transitionOrnot: false,
      startTranslateY: 0,
      splitterModel: 25,
      filter: false,
      filterBy: null,
      disable: true,
      scrollLoading: false,
      back: false,
      search: false,
      cart: false,
      hover: "color:#2c2a74;cursor:pointer;",
      normal: "color:#575757;cursor:pointer;",
      thumbStyle: {
        // right: "4px",
        borderRadius: "1.5px",
        backgroundColor: "#282669",
        // width: "5px",
        height: "3px",
        opacity: 1,
      },
      barStyle: {
        right: "2px",
        borderRadius: "9px",
        backgroundColor: "#027be3",
        width: "9px",
        opacity: 0,
      },
      categoryL1: [],
      categoryL2: [],
      categoryL3: [],
      sizing: null,
      currentCategoryL1: null,
      currentCategoryL2: null,
      currentCategoryL3: null,
      // items: [
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      //   {},
      // ],
      itemsIndex: 0,
      x: 3,
      query: {
        level3: null,
      },
      categoryL2Length: 0,
      nextToken: "",
    };
  },
  computed: {
    items(){
      return this.$store.state["allProduct"]["list"];
    },
    L1(){
      return this.$store.state["allProduct"]["L1"];
    },
    L2(){
      return this.$store.state["allProduct"]["L2"];
    },
    L3(){
      return this.$store.state["allProduct"]["L3"];
    },
    filteredItems(){
      return this.items.filter((item) => {
        return item.availableStore.get(1000);
      })
    },
    loading(){
      return this.$store.state["catalog"].loading;
    },
    // ...mapGetters({
    //   categoryByName: "banners/categoryByName",
    // }),
    // mainBanner() {
    //   return {
    //     height: "27vw",
    //     ratio: 16 / 9,
    //     images: [],
    //     banners: this.categoryByName(this.currentCategoryL1) || [],
    //   };
    // },
    // desktopBanner() {
    //   const half = Math.ceil(this.mainBanner.banners.length / 2);
    //   const left = this.mainBanner.banners.slice(0, half);
    //   const right = this.mainBanner.banners.slice(
    //     -(this.mainBanner.banners.length - left.length)
    //   );
    //   return {
    //     left: {
    //       height: "27vw",
    //       ratio: 16 / 9,
    //       images: [],
    //       banners: left || [],
    //     },
    //     right: {
    //       height: "27vw",
    //       ratio: 16 / 9,
    //       images: [],
    //       banners: right || [],
    //     },
    //   };
    // },
    // IsProductPriceInventoryCatalogsLoaded() {
    //   return true;
    // },
    //   return (this.IsLoaded && this.IsProductPriceInventoryLoaded) || true;
    // },
    // IsProductPriceInventoryCatalogsLoadedCurrentLevel1() {
    //   return {
    //     isProductPriceInventoryCatalogsLoaded:
    //       this.IsProductPriceInventoryCatalogsLoaded,
    //     level1: this.currentCategoryL1,
    //   };
    // },
    // changeSizeIcon() {
    //   switch (this.displaySize) {
    //     case "large":
    //       return "fas fa-th";
    //     default:
    //       return "fas fa-th-large";
    //   }
    // },
    // isDesktop() {
    //   return this.$q.screen.width > 600;
    // },
    topWhiteSpace() {
      return {
        height: `${this.distance.top}px`,
        "max-height": "60px",
        opacity: Math.min(this.distance.top, 60) / 60,
      };
    },
    // filterList() {
    //   let filterList = [
    //     "Price Low-High",
    //     "Price High-Low",
    //     "Name a-z",
    //     "Name z-a",
    //     "Brand a-z",
    //     "Brand z-a",
    //   ];
    //   return filterList;
    // },
    productCardComponent() {
      switch (this.displaySize) {
        case "large":
          return "ProductCardHLarge";
        default:
          return "ProductCardH";
      }
    },
    // combineLevel() {
    //   return {
    //     level1: this.currentCategoryL1,
    //     level2: this.currentCategoryL2,
    //     level3: this.currentCategoryL3,
    //   };
    // },
  },
  watch: {
    L1(value){
      if (this.$refs.scrollContent) {
        this.$refs.scrollContent.reset();
        this.$refs.scrollContent.poll();
      }
    },
    L2(value){
      if (this.$refs.scrollContent) {
        this.$refs.scrollContent.reset();
        this.$refs.scrollContent.poll();
      }
    },
    L3(value){
      if (this.$refs.scrollContent) {
        this.$refs.scrollContent.reset();
        this.$refs.scrollContent.poll();
      }
    },
    // combineLevel({ level1, level2, level3 }) {
    //   if (level1 && level2 && level3) {
    //     const { href } = this.$router.resolve(
    //       `/catalog/${level1}/${level2}/${level3}`
    //     );
    //     window.history.pushState({}, null, href);
    //     return;
    //   }
    //   if (level1 && level3) {
    //     const { href } = this.$router.resolve(`/catalog/${level1}`);
    //     window.history.pushState({}, null, href);
    //     return;
    //   }
    // },
    // IsProductPriceInventoryCatalogsLoadedCurrentLevel1: {
    //   immediate: true,
    //   handler: function (value) {
    //     if (value.isProductPriceInventoryCatalogsLoaded) {
    //       this.reset();
    //       this.disable = false;
    //       console.warn(
    //         "IsProductPriceInventoryCatalogsLoadedCurrentLevel1 scrollTo"
    //       );
    //       window.scrollTo(0, 0);
    //       if (this.$refs.scrollContent) {
    //         this.$refs.scrollContent.reset();
    //         this.$refs.scrollContent.poll();
    //       }
    //     }
    //   },
    // },
    // IsAdditionalCategoryLoaded: {
    //   immediate: false,
    //   handler: function (value) {
    //     console.log("IsAdditionalCategoryLoaded", value);
    //     if (value) {
    //       this.onChangeCategoryL1({
    //         groupName: this.currentCategoryL1,
    //       });
    //     }
    //   },
    // },
    // currentCategoryL2: {
    //   handler: function (level2) {
    //     return;
    //   },
    // },
    // currentCategoryL3: {
    //   handler: function (level3) {
    //     return;
    //   },
    // },
    // filterBy() {
    //   switch (this.filterBy) {
    //     case "Price Low-High": {
    //       return this.items.sort((a, b) => {
    //         if (a.price < b.price) {
    //           return -1;
    //         }
    //         if (a.price > b.price) {
    //           return 1;
    //         }
    //         return 0;
    //       });
    //     }
    //     case "Price High-Low": {
    //       return this.items.sort((a, b) => {
    //         if (a.price < b.price) {
    //           return 1;
    //         }
    //         if (a.price > b.price) {
    //           return -1;
    //         }
    //         return 0;
    //       });
    //     }
    //     case "Name a-z": {
    //       return this.items.sort((a, b) => {
    //         if (a.hema_name_en.toUpperCase() < b.hema_name_en.toUpperCase()) {
    //           return -1;
    //         }
    //         if (a.hema_name_en.toUpperCase() > b.hema_name_en.toUpperCase()) {
    //           return 1;
    //         }
    //         return 0;
    //       });
    //     }
    //     case "Name z-a": {
    //       return this.items.sort((a, b) => {
    //         if (a.hema_name_en.toUpperCase() < b.hema_name_en.toUpperCase()) {
    //           return 1;
    //         }
    //         if (a.hema_name_en.toUpperCase() > b.hema_name_en.toUpperCase()) {
    //           return -1;
    //         }
    //         return 0;
    //       });
    //     }
    //     case "Brand a-z": {
    //       return this.items.sort((a, b) => {
    //         if (a.hema_brand_en.toUpperCase() < b.hema_brand_en.toUpperCase()) {
    //           return -1;
    //         }
    //         if (a.hema_brand_en.toUpperCase() > b.hema_brand_en.toUpperCase()) {
    //           return 1;
    //         }
    //         return 0;
    //       });
    //     }
    //     case "Brand z-a": {
    //       return this.items.sort((a, b) => {
    //         if (a.hema_brand_en.toUpperCase() < b.hema_brand_en.toUpperCase()) {
    //           return 1;
    //         }
    //         if (a.hema_brand_en.toUpperCase() > b.hema_brand_en.toUpperCase()) {
    //           return -1;
    //         }
    //         return 0;
    //       });
    //     }
    //     default:
    //       break;
    //   }
    // },
  },
  mounted() {
    this.currentCategoryL1 = this.L1.name;
    // console.log({L1: this.L1});
    // const { categoryL1, categoryL2, categoryL3 } = this.$route.params;
    // console.log("created", categoryL1, categoryL2, categoryL3);
    // // this.loadCategories();
    // this.currentCategoryL1 = categoryL1 || null;
    // this.currentCategoryL2 = categoryL2 || null;
    // this.currentCategoryL3 = categoryL3 || null;
    // console.log("Quasar", this.$q);
    // if (this.$q.screen.width > 1023) {
    //   this.$store.commit("settings/setDisplaySize", "large");
    // }
  },
  methods: {
    reset() {
      // this.items = [];
      this.nextToken = "";
    },
    async loadCategories() {
      // const branch = this.$store.getters["branch/code"];
      // const productsIsLoaded = this.$store.getters["products/IsLoaded"];
      // const inventoriesIsLoaded = this.$store.getters["inventories/IsLoaded"];
      // const pricesIsLoaded = this.$store.getters["prices/IsLoaded"];
      // if (!productsIsLoaded) {
      //   this.$store.dispatch("products/LoadProducts");
      // }
      // if (!inventoriesIsLoaded) {
      //   this.$store.dispatch("inventories/LoadInventories", {
      //     branch,
      //   });
      // }
      // if (!pricesIsLoaded) {
      //   this.$store.dispatch("prices/LoadPrices", { branch });
      // }
      // await this.$store.dispatch("catalogs/GroupingProducts");
      // this.disable = false;
    },
    // async loadBanners(level1) {
    //   await this.$store.dispatch("banners/LoadAllBanners");
    //   const catBanners = await this.$store.dispatch(
    //     "banners/getCatagoryBanner",
    //     { level1 }
    //   );
    //   console.log("catBanners:", catBanners);
    //   this.mainBanner.banners = catBanners || [];
    //   if (catBanners) {
    //     if (catBanners.length >= 2) {
    //       const half = Math.ceil(catBanners.length / 2);
    //       this.desktopBannerLeft.banners = catBanners.splice(0, half);
    //       this.desktopBannerRight.banners = catBanners.splice(-half);
    //     }
    //   }
    // },
    onLoad(index, done) {
      console.log("onLoad");

      // const newItem = [
      //   {},
      //   {},
      //   {},
      //   {},
      // ]

      // this.items = this.items.concat(newItem);

      this.$store.dispatch("allProduct/loadMore");

      // console.log(this.items, newItem)
      // this.items = [...this.item, ...newItem]

      done();
    },
    onTouchStart(event) {
      console.log("touch!!!!!!!");
      const touchPoint = event.changedTouches[0] || event.touches[0];
      const startLeft = touchPoint.pageX;
      this.touchPoint.startLeft = startLeft;
      const startTop = touchPoint.pageY;
      this.touchPoint.startTop = startTop;
      const startTranslateY = this.translateY;
      this.startTranslateY = startTranslateY;
      const touchTime = new Date().getTime();
      this.touchPoint.startTime = touchTime;
    },
    onTouchMove(event) {
      const touchPoint = event.changedTouches[0] || event.touches[0];
      const distanceTop = touchPoint.pageY - this.touchPoint.startTop;
      this.distance.top = distanceTop;
    },
    onTouchEnd() {
      return;
    },
    // onBack() {
    //   this.$router.push("/");
    // },
    // onCart() {
    //   this.$router.push("/cart");
    //   this.disable = true;
    // },
    // onChangeCategoryL1(L1) {
    //   console.log("onChangeCategoryL1", L1);
    //   this.currentCategoryL1 = L1;
    // },
    // onChangeCategoryL1ByClick(L1) {
    //   console.log("onChangeCategoryL1ByClick", L1);
    //   this.currentCategoryL1 = L1;
    //   this.currentCategoryL2 = null;
    //   this.currentCategoryL3 = null;
    // },
    // async onChangeCategoryL2(L2) {
    //   console.log("onChangeCategoryL2", L2);
    //   this.currentCategoryL2 = L2;
    // },
    // onChangeCategoryL2ByClick(value) {
    //   this.currentCategoryL3 = null;
    //   this.onChangeCategoryL2(value);
    // },
    // onChangeCategoryL3(value) {
    //   // this.reset();
    //   this.disable = false;
    //   // console.warn("onChangeCategoryL3 scrollTo");
    //   window.scrollTo(0, 0);
    //   // this.$refs.scrollContent.reset();
    //   // this.$refs.scrollContent.poll();
    //   this.currentCategoryL3 = value;
    // },
    // onUpdateFilter(value) {
    //   console.log("onUpdateFilter =>", value);
    //   this.filterBy = value;
    //   this.filter = false;
    // },
    // onChangeSize(value) {
    //   switch (value) {
    //     case "fas fa-th-large":
    //       // this.sizing = "fas fa-th";
    //       this.$store.commit("settings/setDisplaySize", "large");
    //       break;
    //     default:
    //       // this.sizing = "fas fa-th-large";
    //       this.$store.commit("settings/setDisplaySize", "small");
    //       break;
    //   }
    // },
    // onProfile() {
    //   this.$router.push("/profile").catch(() => {
    //     return;
    //   });
    //   this.disable = true;
    // },
    // onPromotion() {
    //   this.$router.push("/promotions");
    //   this.disable = true;
    // },
  },
};
</script>

<style scoped>
/* Create two unequal columns that floats next to each other */
.my-column {
  float: left;
  padding: 10px;
  height: 100%; /* Should be removed. Only for demonstration */
}

.my-left {
  width: 25%;
}

.my-right {
  width: 75%;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.header {
  /* position: fixed; */
  /* top: 0px; */
  /* left: 0px; */
  /* right: 0px; */
  /* grid-area: header; */
  border-bottom: 1px solid #ddd;
}
.content {
  height: calc(100% - 70px);
  border: 3px solid purple;
}
.main {
  /* grid-area: main; */
  background-color: white;
  overflow-y: auto;
  position: relative;
  height: calc(100vh - 70px);
  /* border-right: 1px solid #ddd; */
}
.sidebar {
  grid-area: sidebar;
  overflow-y: scroll;
  overflow-x: visible;
}
.addition {
  grid-area: addition;
}

.all-product {
  /* position: fixed; */
  /* position: absolute; */
  /* display: inline-block; */
  /* top: 0px; */
  /* position: fixed; */
  /* top: 0px; */
  /* bottom: 0px; */
  /* left: 0px; */
  /* right: 0px; */
  /* pointer-events: none; */
  /* display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 70px auto;
  grid-template-areas:
    "header header header"
    "sidebar main main"; */
}

/* @media (min-width: 600px) {
  .all-product {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-template-rows: 70px auto;
    grid-template-areas:
      "header header header"
      "sidebar main main";
  }
} */

@media (min-width: 1023px) {
  .all-product {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-template-rows: 70px auto;
    grid-template-areas:
      "header header header"
      "sidebar main addition";
  }
}

.category-level-1 {
  position: fixed;
  top: 0px;
  z-index: 10000;
  background-color: rgba(255, 200, 200, 0.3);
}
.category-level-2 {
  /* position: fixed; */
  /* top: 70px; */
  /* bottom: 0px; */
}
.category-level-3 {
  position: sticky;
  position: -webkit-sticky;
  height: 40px;
  z-index: 9;
}
.backdrop {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.filter-group {
  position: absolute;
  top: 40px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid #ddd;
}
.product-card-h {
  position: relative;
}
.border-green {
  border: 4px solid green;
}
</style>
